import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import site from "@/seo/site.json";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const findPage = (path) => {
  if (site.pages[path]) { return site.pages[path]; }
  const key = Object.keys(site.pages).filter((k) => k !== "/" && path.startsWith(k)).sort((a, b) => b.length - a.length)[0];
  return site.pages[key] || site.pages["/"];
};

export function RouteSeo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = findPage(pathname);
    const index = !!page.index && pathname === "/";
    const url = `${site.base}${pathname}`;
    document.title = page.title;
    setMeta("name", "description", page.description);
    setMeta("name", "robots", index ? "index, follow" : "noindex, follow");
    setMeta("property", "og:title", page.title);
    setMeta("property", "og:description", page.description);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", page.title);
    setMeta("name", "twitter:description", page.description);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (index) {
      if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
      link.href = url;
    } else if (link) { link.remove(); }
    document.querySelectorAll('script[data-seo="home"]').forEach((s) => { if (!index) { s.remove(); } });
  }, [pathname]);
  return null;
}
